export enum PermissionList {
  // PAYMENT PERMISSIONS:
  PAYMENT_MANAGER_LIST = 'payment_manager_list',
  PAYMENT_MANAGER_EXPORT_CSV = 'payment_manager_export_csv',

  // SUBMIT_AGREEMENT PERMISSIONS:
  SUBMIT_AGREEMENT_LIST = 'submit_agreement_list',
  SUBMIT_AGREEMENT_CREATE = 'submit_agreement_create',
  SUBMIT_AGREEMENT_EDIT = 'submit_agreement_edit',
  SUBMIT_AGREEMENT_DELETE = 'submit_agreement_delete',
  SUBMIT_AGREEMENT_SEARCH_LIST = 'submit_agreement_search_list',

  // CLIENT PERMISSIONS:
  CLIENT_LIST = 'client_list',
  CLIENT_IMPORT_CSV = 'client_import',
  CLIENT_EXPORT_CSV = 'client_export_csv',
  CLIENT_CREATE = 'client_create',
  CLIENT_DETAIL = 'client_detail',
  CLIENT_EDIT = 'client_edit',
  CLIENT_DELETE = 'client_delete',
  CLIENT_SEARCH_LIST = 'client_search_list',

  // CUSTOMER PERMISSIONS:
  CUSTOMER_LIST = 'customer_list',
  CUSTOMER_IMPORT_CSV = 'customer_import',
  CUSTOMER_EXPORT_CSV = 'customer_export_csv',
  CUSTOMER_CREATE = 'customer_create',
  CUSTOMER_DETAIL = 'customer_detail',
  CUSTOMER_EDIT = 'customer_edit',
  CUSTOMER_DELETE = 'customer_delete',
  CUSTOMER_SEARCH_LIST = 'customer_search_list',

  // REPAIR PERMISSIONS:
  REPAIR_LIST = 'repair_list',
  REPAIR_CREATE = 'repair_create',
  REPAIR_DETAIL = 'repair_detail',
  REPAIR_EDIT = 'repair_edit',
  REPAIR_DELETE = 'repair_delete',

  // ACCOUNT PERMISSIONS:
  ACCOUNT_LIST = 'account_list',
  ACCOUNT_CREATE = 'account_create',
  ACCOUNT_DETAIL = 'account_detail',
  ACCOUNT_EDIT = 'account_edit',
  ACCOUNT_DELETE = 'account_delete',

  // PERMISSIONS:
  PERMISSION_LIST = 'permission_list',
  PERMISSION_CREATE = 'permission_create',
  PERMISSION_EDIT = 'permission_edit',
  PERMISSION_DELETE = 'permission_delete',

  // REPAIR_AGREEMENT_LINK PERMISSIONS:
  ENABLING_REPAIR_AGREEMENT_LINK = 'enabling_repair_agreement_link',

  // MAKER PERMISSIONS:
  MAKER_LIST = 'maker_list',
  MAKER_CREATE = 'maker_create',
  MAKER_EDIT = 'maker_edit',
  MAKER_DELETE = 'maker_delete',

  // MODEL PERMISSIONS:
  MODEL_LIST = 'model_list',
  MODEL_CREATE = 'model_create',
  MODEL_EDIT = 'model_edit',
  MODEL_DELETE = 'model_delete',

  // CATEGORY PERMISSIONS:
  CATEGORY_LIST = 'category_list',
  CATEGORY_CREATE = 'category_create',
  CATEGORY_EDIT = 'category_edit',
  CATEGORY_DELETE = 'category_delete',

  // PLAN PERMISSIONS
  PLAN_LIST = 'plan_list',
  PLAN_CREATE = 'plan_create',
  PLAN_DETAIL = 'plan_detail',
  PLAN_EDIT = 'plan_edit',
  PLAN_DELETE = 'plan_delete',

  // IMEI PERMISSIONS
  IMEI_CREATE = 'imei_create',
  IMEI_EDIT = 'imei_edit',

  // AGENCY PERMISSIONS
  AGENCY_LIST = 'agency_list',
  AGENCY_CREATE = 'agency_create',
  AGENCY_DETAIL = 'agency_detail',
  AGENCY_EDIT = 'agency_edit',
  AGENCY_DELETE = 'agency_delete',
  AGENCY_INHERITED_PLAN_ADD = 'agency_inherited_plan_add',
  AGENCY_INHERITED_PLAN_DELETE = 'agency_inherited_plan_delete',
  AGENCY_EXCLUDED_PLAN_ADD = 'agency_excluded_plan_add',
  AGENCY_EXCLUDED_PLAN_DELETE = 'agency_excluded_plan_delete',

  // AGENCY_AUTHORITY PERMISSIONS
  AGENCY_AUTHORITY_LIST = 'agency_authority_list',
  AGENCY_AUTHORITY_EDIT = 'agency_authority_edit',
  AGENCY_AUTHORITY_DETAIL = 'agency_authority_detail',
  AGENCY_AUTHORITY_APPROVED = 'agency_authority_approved',

  // QR_REGISTER PERMISSIONS
  QR_REGISTER_LIST = 'qr_register_list',
  QR_REGISTER_CREATE = 'qr_register_create',
  QR_REGISTER_DELETE = 'qr_register_delete',

  // SALE PERMISSIONS
  SALES_MANAGER_LIST = 'sales_manager_list',
  SALES_MANAGER_EXPORT_CSV = 'sales_manager_export_csv',

  // COUNT SETTING-NUMBER PERMISSIONS
  COUNT_CALLS_LIST = 'call_count_list',
  COUNT_CALLS_CREATE = 'call_count_create',
  COUNT_CALLS_EDIT = 'call_count_edit',
  COUNT_CALLS_DELETE = 'call_count_delete',

  COUNT_REPAIRS_LIST = 'repair_count_list',
  COUNT_REPAIRS_CREATE = 'repair_count_create',
  COUNT_REPAIRS_EDIT = 'repair_count_edit',
  COUNT_REPAIRS_DELETE = 'repair_count_delete',

  // CUSTOM-MAIL
  MAIL_LOGIN_DETAIL = 'mail_login_detail',
  MAIL_LOGIN_EDIT = 'mail_login_edit',

  MAIL_PLAN_COMPLETE_DETAIL = 'mail_plan_complete_detail',
  MAIL_PLAN_COMPLETE_EDIT = 'mail_plan_complete_edit',

  MAIL_PAYMENT_SUCCESS_DETAIL = 'mail_payment_success_detail',
  MAIL_PAYMENT_SUCCESS_EDIT = 'mail_payment_success_edit',

  MAIL_PAYMENT_FAIL_DETAIL = 'mail_payment_fail_detail',
  MAIL_PAYMENT_FAIL_EDIT = 'mail_payment_fail_edit',

  // TEST SEND MAIL
  TEST_SEND_MAIL = 'test_send_mail',

  // Dashboard - Quick Report permissions
  QUICK_REPORT_KPI_SUMMARY_VIEW = 'quick_report_kpi_summary_view',
  QUICK_REPORT_REVENUE_STRUCTURE_VIEW = 'quick_report_revenue_structure_view',
  QUICK_REPORT_MEMBER_SALES_STRUCTURE_VIEW = 'quick_report_member_sales_structure_view',
  QUICK_REPORT_AGENCY_BREAKDOWN_VIEW = 'quick_report_agency_breakdown_view',
  QUICK_REPORT_INQUIRY_WORK_STATUS_VIEW = 'quick_report_inquiry_work_status_view',
  QUICK_REPORT_AGENCY_RANKING_VIEW = 'quick_report_agency_ranking_view',
  QUICK_REPORT_PLAN_RANKING_VIEW = 'quick_report_plan_ranking_view',
  QUICK_REPORT_SALES_UP_AGENCIES_VIEW = 'quick_report_sales_up_agencies_view',
  QUICK_REPORT_SALES_DOWN_AGENCIES_VIEW = 'quick_report_sales_down_agencies_view',

  // Dashboard - Confirmed Report permissions
  CONFIRMED_REPORT_KPI_SUMMARY_VIEW = 'confirmed_report_kpi_summary_view',
  CONFIRMED_REPORT_REVENUE_STRUCTURE_VIEW = 'confirmed_report_revenue_structure_view',
  CONFIRMED_REPORT_MEMBER_SALES_STRUCTURE_VIEW = 'confirmed_report_member_sales_structure_view',
  CONFIRMED_REPORT_AGENCY_BREAKDOWN_VIEW = 'confirmed_report_agency_breakdown_view',
  CONFIRMED_REPORT_INQUIRY_WORK_STATUS_VIEW = 'confirmed_report_inquiry_work_status_view',
  CONFIRMED_REPORT_AGENCY_RANKING_VIEW = 'confirmed_report_agency_ranking_view',
  CONFIRMED_REPORT_PLAN_RANKING_VIEW = 'confirmed_report_plan_ranking_view',
  CONFIRMED_REPORT_SALES_UP_AGENCIES_VIEW = 'confirmed_report_sales_up_agencies_view',
  CONFIRMED_REPORT_SALES_DOWN_AGENCIES_VIEW = 'confirmed_report_sales_down_agencies_view',
  CONFIRMED_REPORT_BILLING_REVENUE_CHART_VIEW = 'confirmed_report_billing_revenue_chart_view',
  CONFIRMED_REPORT_SUBSCRIPTION_MEMBERS_CHART_VIEW = 'confirmed_report_subscription_members_chart_view',
  CONFIRMED_REPORT_SHOT_TRANSACTIONS_CHART_VIEW = 'confirmed_report_shot_transactions_chart_view'
}
